var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Checkbox, Dimmer, Grid, Header, Input, Loader, Modal, Select, Table } from "semantic-ui-react";
import AddressEditForm from "../AddressForm";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
var CreateShipmentModal = /** @class */ (function (_super) {
    __extends(CreateShipmentModal, _super);
    function CreateShipmentModal(props) {
        var _this = _super.call(this, props) || this;
        _this.setShippingAddressState = function (s) {
            _this.setState(function (oldState) {
                return {
                    shippingAddress: Object.assign({}, oldState.shippingAddress, s),
                    validAddress: false,
                    estimatedShipmentPrice: 0,
                    recommendedAddress: undefined
                };
            });
        };
        _this.useRecommendedAddress = function (recommendedAddress) {
            return function () {
                _this.setState({
                    shippingAddress: recommendedAddress
                });
            };
        };
        _this.onChangeName = function (event, data) {
            var name = data.value;
            _this.setState({ customerName: name });
        };
        _this.onChangeCompanyName = function (event, data) {
            var name = data.value;
            _this.setState({ companyName: name });
        };
        _this.onChangeNumber = function (event, data) {
            var updatedNumber = data.value;
            _this.setState({ recipientNumber: updatedNumber });
        };
        _this.onNoteChange = function (event, data) {
            var updatedNote = data.value;
            _this.setState({ note: updatedNote });
        };
        _this.onPayorAccountNumberChange = function (event, data) {
            var accountNumber = data.value;
            _this.setState({ payorAccountNumber: accountNumber, estimatedShipmentPrice: 0 });
        };
        _this.onTotalPackageWeightChange = function (event, data) {
            var v = data.value;
            var num = parseInt(v, 10);
            if (isNaN(num)) {
                // no op -- discard input
                return;
            }
            _this.setState({ packageTotalWeight: num, estimatedShipmentPrice: 0 });
        };
        _this.onLengthChange = function (event, data) {
            var v = data.value;
            var num = parseInt(v, 10);
            if (isNaN(num)) {
                // no op -- discard input
                return;
            }
            _this.setState({ length: num, estimatedShipmentPrice: 0 });
        };
        _this.onWidthChange = function (event, data) {
            var v = data.value;
            var num = parseInt(v, 10);
            if (isNaN(num)) {
                // no op -- discard input
                return;
            }
            _this.setState({ width: num, estimatedShipmentPrice: 0 });
        };
        _this.onHeightChange = function (event, data) {
            var v = data.value;
            var num = parseInt(v, 10);
            if (isNaN(num)) {
                // no op -- discard input
                return;
            }
            _this.setState({ height: num, estimatedShipmentPrice: 0 });
        };
        _this.onDryIceWeightChange = function (event, data) {
            var v = data.value;
            var num = parseInt(v, 10);
            if (isNaN(num)) {
                // no op -- discard input
                return;
            }
            _this.setState({ packageDryIceWeight: num, estimatedShipmentPrice: 0 });
        };
        _this.onPaymentTypeChange = function (event, data) {
            _this.setState({ paymentType: data.value, payorAccountNumber: "", estimatedShipmentPrice: 0 });
        };
        _this.dryIceToggle = function (event, data) {
            var checked = data.checked === true;
            _this.setState({ includeDryIce: checked, estimatedShipmentPrice: 0 });
        };
        _this.onPoNumberChange = function (event, data) {
            var val = data.value;
            if (typeof val !== 'string') {
                throw new Error("Unexpected type value: " + val);
            }
            _this.setState({
                poNum: val
            });
        };
        _this.onPresetBoxesChange = function (event, data) {
            var val = data.value;
            if (typeof val !== 'string') {
                throw new Error("Unexpected type value: " + val);
            }
            if (val === "Small") {
                _this.setState({
                    length: 12,
                    width: 10,
                    height: 15,
                    boxSize: val,
                    customBoxSize: false
                });
            }
            else if (val === "Medium") {
                _this.setState({
                    length: 15,
                    width: 12,
                    height: 13,
                    boxSize: val,
                    customBoxSize: false
                });
            }
            else if (val === "Large") {
                _this.setState({
                    length: 16,
                    width: 14,
                    height: 13,
                    boxSize: val,
                    customBoxSize: false
                });
            }
            else {
                _this.setState({
                    length: 0,
                    width: 0,
                    height: 0,
                    boxSize: val,
                    customBoxSize: true
                });
            }
        };
        _this.currentPoNums = function () {
            var poNums;
            if (_this.props.poNums.find(function (p) { return p === _this.state.poNum; }) === undefined) {
                poNums = _this.props.poNums.map(function (p) { return ({ text: p, value: p }); });
                poNums.push({ text: _this.state.poNum, value: _this.state.poNum });
                return poNums;
            }
            else {
                poNums = _this.props.poNums.map(function (po) { return ({ value: po, text: po }); });
                return poNums;
            }
        };
        _this.onReferenceChange = function (event, data) {
            _this.setState({ reference: data.value });
        };
        _this.submit = function () {
            _this.props.postRequest("/admin/orders/id/" + encodeURIComponent(_this.props.order.id) + "/shipments/id/" + encodeURIComponent(_this.props.shipmentId) + "/create-shipping-label", {
                customerName: _this.state.customerName,
                companyName: _this.state.companyName,
                packageTotalWeight: _this.state.packageTotalWeight,
                packageDryIceWeight: _this.state.packageDryIceWeight,
                shippingAddress: _this.state.shippingAddress,
                recipientNumber: _this.state.recipientNumber,
                paymentType: _this.state.paymentType,
                includeDryIce: _this.state.includeDryIce,
                validAddress: _this.state.validAddress,
                note: _this.state.note,
                payorAccountNumber: _this.state.payorAccountNumber,
                reference: _this.state.reference,
                poNumber: _this.state.poNum,
                dimensions: {
                    length: _this.state.length,
                    width: _this.state.width,
                    height: _this.state.height,
                    units: _this.state.units
                },
                subtotalPrice: _this.state.subtotalPrice
            });
        };
        _this.validateAddress = function () {
            _this.props.postRequestWithJsonResponse("/admin/orders/id/" + encodeURIComponent(_this.props.order.id) + "/shipments/id/" + encodeURIComponent(_this.props.shipmentId) + "/validate-shipment-address", {
                shippingAddress: _this.state.shippingAddress
            }, function (resp) {
                var line2 = "";
                if (resp.streetLinesToken.length > 1) {
                    line2 = resp.streetLinesToken[1];
                }
                _this.setState({
                    validAddress: resp.attributes.Resolved,
                    recommendedAddress: {
                        city: resp.cityToken[0].value,
                        street: resp.streetLinesToken[0],
                        streetLine2: line2,
                        zipPostalCode: resp.postalCodeToken.value,
                        countryCode: resp.countryCode,
                        stateProvince: resp.stateOrProvinceCodeToken.value
                    }
                }, function () {
                    _this.props.setState(function () { return ({ success: false }); });
                });
            });
        };
        _this.getShippingQuote = function () {
            _this.props.postRequestWithJsonResponse("/admin/orders/id/" + encodeURIComponent(_this.props.order.id) + "/shipments/id/" + encodeURIComponent(_this.props.shipmentId) + "/get-fedex-quote", {
                customerName: _this.state.customerName,
                packageTotalWeight: _this.state.packageTotalWeight,
                companyName: _this.state.companyName,
                packageDryIceWeight: _this.state.packageDryIceWeight,
                shippingAddress: _this.state.shippingAddress,
                recipientNumber: _this.state.recipientNumber,
                paymentType: _this.state.paymentType,
                includeDryIce: _this.state.includeDryIce,
                validAddress: _this.state.validAddress,
                note: _this.state.note,
                payorAccountNumber: _this.state.payorAccountNumber,
                poNumber: "",
                reference: "",
                dimensions: {
                    length: _this.state.length,
                    width: _this.state.width,
                    height: _this.state.height,
                    units: _this.state.units
                },
                subtotalPrice: _this.state.subtotalPrice
            }, function (resp) {
                _this.setState({
                    estimatedShipmentPrice: resp.totalNetCharge
                }, function () {
                    _this.props.setState(function () { return ({ success: false }); });
                });
            });
        };
        _this.state = {
            loading: false,
            success: false,
            packageTotalWeight: 10,
            packageDryIceWeight: 8,
            includeDryIce: true,
            shippingAddress: _this.props.shippingAddress,
            customerName: _this.props.customerName,
            companyName: _this.props.companyName,
            recipientNumber: _this.props.recipientNumber,
            validAddress: false,
            length: 12,
            width: 10,
            height: 15,
            units: "IN",
            note: "",
            payorAccountNumber: "",
            paymentType: paymentTypeOptions[0].value,
            estimatedShipmentPrice: 0,
            reference: _this.props.customerName,
            poNum: "",
            boxSize: "Small",
            customBoxSize: false,
            subtotalPrice: _this.props.order.kitSubtotalCents / 100
        };
        return _this;
    }
    CreateShipmentModal.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, null,
            React.createElement(Dimmer, { active: this.props.state.loading, inverted: true },
                React.createElement(Loader, null)),
            React.createElement("p", null,
                "Estimated Cost: ",
                this.state.estimatedShipmentPrice !== 0 ? "$" + this.state.estimatedShipmentPrice : "TBD"),
            React.createElement(Header, null, "Recipient Address"),
            React.createElement("div", { className: 'field-group' },
                React.createElement(Grid, { columns: 3 },
                    React.createElement(AddressEditForm, { disabled: this.state.success, errorPathPrefix: '/shippingAddress', errors: this.props.state.errors, address: this.state.shippingAddress, setAddressState: this.setShippingAddressState }),
                    React.createElement(Grid.Column, null,
                        this.state.validAddress && React.createElement(Button, { positive: true, color: 'green', icon: 'check' }),
                        !this.state.validAddress && React.createElement(Button, { negative: true, color: 'red', icon: 'x' }),
                        React.createElement(Button, { onClick: this.validateAddress, label: 'Validate Address', labelPosition: 'left', icon: 'search', positive: true })),
                    React.createElement(Grid.Column, null, (this.state.recommendedAddress != null && this.state.shippingAddress !== this.state.recommendedAddress)
                        && React.createElement("div", null,
                            React.createElement("p", null, "Would you like to use the FedEx recommended address?"),
                            React.createElement(Modal, { closeIcon: true, trigger: React.createElement(Button, { icon: 'eye', label: 'View Address', labelPosition: 'left' }) },
                                React.createElement(Modal.Header, null, "Recommended Address"),
                                React.createElement(Modal.Content, null,
                                    React.createElement(Table, { striped: true, celled: true },
                                        React.createElement(Table.Header, null,
                                            React.createElement(Table.Row, null,
                                                React.createElement(Table.HeaderCell, null),
                                                React.createElement(Table.HeaderCell, null, "Recommended"),
                                                React.createElement(Table.HeaderCell, null, "Current")),
                                            React.createElement(Table.Row, null,
                                                React.createElement(Table.HeaderCell, null, "Street Address"),
                                                React.createElement(Table.Cell, null, this.state.recommendedAddress.street),
                                                React.createElement(Table.Cell, null, this.state.shippingAddress.street)),
                                            React.createElement(Table.Row, null,
                                                React.createElement(Table.HeaderCell, null, "Room/Suite/Other"),
                                                React.createElement(Table.Cell, null, this.state.recommendedAddress.streetLine2),
                                                React.createElement(Table.Cell, null, this.state.shippingAddress.streetLine2)),
                                            React.createElement(Table.Row, null,
                                                React.createElement(Table.HeaderCell, null, "City"),
                                                React.createElement(Table.Cell, null, this.state.recommendedAddress.city),
                                                React.createElement(Table.Cell, null, this.state.shippingAddress.city)),
                                            React.createElement(Table.Row, null,
                                                React.createElement(Table.HeaderCell, null, "State / Province"),
                                                React.createElement(Table.Cell, null, this.state.recommendedAddress.stateProvince),
                                                React.createElement(Table.Cell, null, this.state.shippingAddress.stateProvince)),
                                            React.createElement(Table.Row, null,
                                                React.createElement(Table.HeaderCell, null, "Zip / Postal Code"),
                                                React.createElement(Table.Cell, null, this.state.recommendedAddress.zipPostalCode),
                                                React.createElement(Table.Cell, null, this.state.shippingAddress.zipPostalCode)),
                                            React.createElement(Table.Row, null,
                                                React.createElement(Table.HeaderCell, null, "Country"),
                                                React.createElement(Table.Cell, null, this.state.recommendedAddress.countryCode),
                                                React.createElement(Table.Cell, null, this.state.shippingAddress.countryCode)))),
                                    React.createElement(Button, { label: 'Use Recommended Address', labelPosition: 'left', icon: 'exchange', onClick: this.useRecommendedAddress(this.state.recommendedAddress) }))))))),
            React.createElement(Header, null, "Shipping Information"),
            React.createElement("div", { className: 'field-group' },
                React.createElement(Grid, { columns: 4 },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/customerName', labelContent: React.createElement(React.Fragment, null, "Customer Name") },
                                React.createElement(Input, { onChange: this.onChangeName, value: this.state.customerName }))),
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/companyName', labelContent: React.createElement(React.Fragment, null, "Company Name") },
                                React.createElement(Input, { onChange: this.onChangeCompanyName, value: this.state.companyName }))),
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/recipientNumber', labelContent: React.createElement(React.Fragment, null, "Recipient Phone #") },
                                React.createElement(Input, { onChange: this.onChangeNumber, value: this.state.recipientNumber }))),
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/paymentType', labelContent: React.createElement(React.Fragment, null, "Payment Type") },
                                React.createElement(Select, { search: false, options: paymentTypeOptions, onChange: this.onPaymentTypeChange, value: this.state.paymentType })))),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/boxSize', labelContent: 'Box Size' },
                                React.createElement(Select, { options: [
                                        { text: "Small 12x10x15", value: "Small" },
                                        { text: "Medium Box 15x12x13", value: "Medium" },
                                        { text: "Large Box 16x14x13", value: "Large" },
                                        { text: "Custom Size", value: "Custom" },
                                    ], onChange: this.onPresetBoxesChange, value: this.state.boxSize }))),
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/packageTotalWeight', labelContent: React.createElement(React.Fragment, null, "Total Weight (LB)") },
                                React.createElement(Input, { type: 'number', onChange: this.onTotalPackageWeightChange, value: this.state.packageTotalWeight }))),
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/poNum', labelContent: React.createElement(React.Fragment, null, "PO Number") },
                                React.createElement(Select, { options: this.currentPoNums(), allowAdditions: true, onChange: this.onPoNumberChange, search: true, clearable: true, value: this.state.poNum }))),
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/reference', labelContent: React.createElement(React.Fragment, null, "Reference") },
                                React.createElement(Input, { onChange: this.onReferenceChange, value: this.state.reference })))),
                    this.state.customBoxSize && React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/length', labelContent: React.createElement(React.Fragment, null, "Length (in.)") },
                                React.createElement(Input, { type: 'number', onChange: this.onLengthChange, value: this.state.length }))),
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/width', labelContent: React.createElement(React.Fragment, null, "Width (in.)") },
                                React.createElement(Input, { type: 'number', onChange: this.onWidthChange, value: this.state.width }))),
                        React.createElement(Grid.Column, null,
                            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/height', labelContent: React.createElement(React.Fragment, null, "Height (in.)") },
                                React.createElement(Input, { type: 'number', onChange: this.onHeightChange, value: this.state.height })))),
                    (this.state.includeDryIce || this.state.paymentType !== "SENDER") && React.createElement(Grid.Row, null,
                        this.state.includeDryIce &&
                            React.createElement(Grid.Column, null,
                                React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/dryIceWeight', labelContent: React.createElement(React.Fragment, null, "Dry Ice Weight (LB)") },
                                    React.createElement(Input, { type: 'number', onChange: this.onDryIceWeightChange, value: this.state.packageDryIceWeight }))),
                        this.state.paymentType !== "SENDER" &&
                            React.createElement(Grid.Column, null,
                                React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/payorAccountNumber', labelContent: React.createElement(React.Fragment, null, "Payor Account #") },
                                    React.createElement(Input, { onChange: this.onPayorAccountNumberChange, value: this.state.payorAccountNumber })))),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, null,
                            React.createElement(Checkbox, { disabled: this.state.success, label: 'Shipment Contains Dry Ice', onChange: this.dryIceToggle, checked: this.state.includeDryIce }))))),
            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/note', labelContent: React.createElement(React.Fragment, null, "Note") },
                React.createElement(Input, { onChange: this.onNoteChange, value: this.state.note })),
            React.createElement(Button, { disabled: this.state.loading || this.state.success, icon: 'plus', label: 'Create Shipping Label', labelPosition: 'left', onClick: this.submit, positive: true }),
            React.createElement(Button, { label: 'Get Shipment Quote', labelPosition: 'left', disabled: this.state.loading || this.state.success, onClick: this.getShippingQuote, positive: true, icon: 'dollar sign' }));
    };
    return CreateShipmentModal;
}(React.PureComponent));
export default CreateShipmentModal;
var paymentTypeOptions = [
    {
        text: "SENDER",
        value: "SENDER"
    },
    {
        text: "RECIPIENT",
        value: "RECIPIENT"
    },
    {
        text: "THIRD PARTY",
        value: "THIRD_PARTY"
    }
];
//# sourceMappingURL=CreateShipmentModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/CreateShipmentModal.js
// module id = 1184
// module chunks = 0